import React from 'react';

/**
 * MetadataCard displays recipe metadata (prep time, cook time, total time,
 * servings, difficulty) in a scannable, accessible layout.
 *
 * @param {Object} props
 * @param {string} props.prepTime - Human-readable prep duration
 * @param {string} props.cookTime - Human-readable cook duration
 * @param {number} props.servings - Number of servings
 * @param {'easy'|'medium'|'hard'} props.difficulty - Recipe difficulty level
 */
const MetadataCard = ({ prepTime, cookTime, servings, difficulty }) => {
  const totalTime = `${prepTime} + ${cookTime}`;

  return (
    <section className="metadata-card" aria-label="Recipe metadata">
      <div className="metadata-items">
        <div className="metadata-item" aria-label={`Prep time: ${prepTime}`}>
          <i className="fas fa-clock" aria-hidden="true"></i>
          <span className="metadata-label">Prep Time</span>
          <span className="metadata-value">{prepTime}</span>
        </div>

        <div className="metadata-item" aria-label={`Cook time: ${cookTime}`}>
          <i className="fas fa-fire" aria-hidden="true"></i>
          <span className="metadata-label">Cook Time</span>
          <span className="metadata-value">{cookTime}</span>
        </div>

        <div className="metadata-item" aria-label={`Total time: ${totalTime}`}>
          <i className="fas fa-hourglass-half" aria-hidden="true"></i>
          <span className="metadata-label">Total Time</span>
          <span className="metadata-value">{totalTime}</span>
        </div>

        <div className="metadata-item" aria-label={`Servings: ${servings}`}>
          <i className="fas fa-users" aria-hidden="true"></i>
          <span className="metadata-label">Servings</span>
          <span className="metadata-value">{servings}</span>
        </div>

        <div className="metadata-item" aria-label={`Difficulty: ${difficulty}`}>
          <i className="fas fa-signal" aria-hidden="true"></i>
          <span className="metadata-label">Difficulty</span>
          <span className="metadata-value">{difficulty}</span>
        </div>
      </div>
    </section>
  );
};

export default MetadataCard;
